// extracted by mini-css-extract-plugin
module.exports = {"Follow":"Follow_Follow__3N4fO","FollowSpan":"Follow_FollowSpan__1oFCG","youtube":"Follow_youtube__1O0aZ"};